import { ClerkProvider } from "@clerk/clerk-react";
import { dark } from "@clerk/themes";
import { useTheme } from "../contexts/ThemeContext";

// Import your Publishable Key
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key");
}

export const ClerkProviderWithRoutes = ({ children }) => {
  const { theme } = useTheme();

  // Use the History API so this provider can be mounted outside the RouterProvider.
  const routerPush = (to) => {
    if (typeof window === "undefined") return;
    try {
      window.history.pushState({}, "", to);
      window.dispatchEvent(new PopStateEvent("popstate"));
    } catch (e) {
      // Fallback to full navigation
      window.location.assign(to);
    }
  };

  const routerReplace = (to) => {
    if (typeof window === "undefined") return;
    try {
      window.history.replaceState({}, "", to);
      window.dispatchEvent(new PopStateEvent("popstate"));
    } catch (e) {
      window.location.replace(to);
    }
  };

  return (
    <ClerkProvider
      routerPush={routerPush}
      routerReplace={routerReplace}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      publishableKey={PUBLISHABLE_KEY}
      appearance={{
        baseTheme: theme === "dark" ? dark : undefined,
      }}
    >
      {children}
    </ClerkProvider>
  );
};
export default ClerkProviderWithRoutes;
